import { cn } from '@nesso/ui/lib/utils';
import { Textarea } from '@nesso/ui/primitives/textarea';

const DEFAULT_MAX_LENGTH = 1000;

type Props = {
    autoFocus?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
    rows?: number;
    variant?: 'default' | 'quote' | 'inline';
    maxLength?: number;
};

export function NoteTextarea({
    autoFocus,
    value,
    onChange,
    placeholder,
    className,
    rows = 3,
    variant = 'default',
    maxLength = DEFAULT_MAX_LENGTH,
}: Props) {
    return (
        <Textarea
            autoFocus={autoFocus}
            value={value ?? ''}
            rows={rows}
            onChange={(e) => {
                const next = e.target.value.slice(0, maxLength);
                onChange?.(next);
            }}
            placeholder={placeholder}
            maxLength={maxLength}
            className={cn(
                'field-sizing-content resize-none overflow-hidden leading-relaxed',
                'bg-muted/40 dark:bg-input/30 border-border/60',
                'min-h-[4.9375rem]',
                variant === 'quote' && 'italic',
                variant === 'inline' && 'min-h-10 py-2',
                className,
            )}
        />
    );
}
